import UnavailableSVG from '../../assets/svg/largeSVGImages/currentlyUnavailable.svg';
import UnavailableSVGsmall from '../../assets/svg/largeSVGImages/currentlyUnavailableSmall.svg';
import './Currently_unavailable_div.css';

import {Card, CardContent, Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';

const CurrentlyUnavailableCard = (props) => {
  const {t} = useTranslation();
  return (
    <div
      className={`unavailableParent ${
        props.fullScreen ? 'fullHeight' : 'halfHeight'
      }`}
      id={'unavailableParent'}
    >
      <Card className="unavailableCard">
        <CardContent className="unavailableCardContent">
          <div className="unavailableLogo">
            {props.fullScreen ? (
              <img
                className="svgAsUrl"
                src={props.customImage ? props.customImage : UnavailableSVG}
                alt="logo"
              />
            ) : (
              <img
                className="svgAsUrl"
                src={
                  props.customImage ? props.customImage : UnavailableSVGsmall
                }
                alt="logo"
              />
            )}
          </div>
          <div className="cardTitle">{props.title}</div>
          <div className="cardSubTitle">{props.subTitle}</div>
          {props.handleReload && (
            <Button
              variant="primary"
              id="reloadBtn"
              data-testid="reloadBtn"
              onClick={() => props.handleReload()}
            >
              {t('RELOAD')}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CurrentlyUnavailableCard;
